/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ProjectUserStatusType {

    ACTIVE = 'ACTIVE',

    INACTIVE = 'INACTIVE',

    INVITED = 'INVITED',

    CREATED = 'CREATED',

    REJECTED = 'REJECTED',

    EMAIL_ERROR = 'EMAIL_ERROR'
}

